import React, { useState } from "react";
import PolicyEditor from "@/components/policies/PolicyEditor";
import HostOnboardingStatus from "@/components/policies/HostOnboardingStatus";

const VIEWS = [{ id: "editor", label: "Policies" }, { id: "onboarding", label: "Host Onboarding" }];

export default function PolicyAdmin() {
  const [view, setView] = useState("editor");
  return (
    <div data-testid="policy-admin">
      <div className="mb-6 flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <div className="label-eyebrow text-[var(--ff-red)] mb-1">▮ COMPANY POLICIES</div>
          <h2 className="font-display text-3xl">Policies &amp; Host Onboarding</h2>
          <p className="text-[var(--ff-text-dim)] text-sm mt-1 max-w-2xl">
            Published publicly at <a href="/policies" className="text-white underline">/policies</a>. New or re-read policies pop up for staff &amp; hosts, and hosts must read every policy before the Host Dashboard unlocks.
          </p>
        </div>
        <div className="flex gap-px bg-[var(--ff-border)] w-fit">
          {VIEWS.map((v) => (
            <button key={v.id} onClick={() => setView(v.id)} data-testid={`policy-admin-view-${v.id}`}
              className={`px-4 py-2 font-mono-ui text-xs uppercase tracking-[0.15em] transition-colors ${view === v.id ? "bg-[var(--ff-red)] text-white" : "bg-[var(--ff-bg)] text-[var(--ff-text-dim)] hover:text-white"}`}>
              {v.label}
            </button>
          ))}
        </div>
      </div>
      {view === "editor" ? <PolicyEditor /> : <HostOnboardingStatus />}
    </div>
  );
}
